import PlayerBasicModel from "../../../Football/Models/Player/PlayerBasicModel";

export default class FixturePredictionModel {
    public value: any = null;
    public playerId: string = null;
    public playerModel?: PlayerBasicModel = null;
    public playerRole?: string;
}